export default __webpack_public_path__ + "static/gallery3-f4312592056a0489251f0859ac8bdfe4.png";